import { useMutation, useQuery } from "@tanstack/react-query";
import { useGet, usePost } from "../../api-service";
import { UserRoles } from "../../enums/user-roles";
import { RoleModel } from "../../../main/roles/api/types";

const dummyRoleModel: RoleModel = {
  id: "UU7btIQJU3Hj4v8Epdi7078Y8SrQ6dmJGn4tetjeL2LhrcdlreuuA3QrmTyqxso/",
  name: "CoGroupAdmin",
  displayName: "Co Group Admin",
  role: UserRoles.CoGroupAdmin,
};

export const useGetSpecificRole = (
  role: UserRoles,
  walkthroughMode?: boolean
) => {
  const { post } = usePost();
  var url = `/api/roles/role?Role=${role}`;

  return useMutation({
    mutationFn: async (code: string) => {
      if (walkthroughMode) {
        console.log("Walkthrough mode - returning specific dummy role");
        return Promise.resolve(dummyRoleModel);
      }
      return post<undefined, RoleModel>(url, undefined, false);
    },
  });
};
